export * from "modules/AppointmentDetails/components/CustomerCommunicationModal/hooks/useCustomerCommunication";
